export const LANDING_PAGE_TEXTS = {
    TITLE: 'landing-page__title',
    SUBTITLE: 'landing-page__subtitle',
    DESCRIPTION: 'landing-page__description',
    GAME_NAME: 'gameName',
    SCROLL_LINK: 'landing-page__scroll-link'
};
